module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("vux-loader 介绍")]), _vm._v(" "), _c('p', {
    attrs: {
      "align": "left"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.npmjs.com/package/vux-loader"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://img.shields.io/npm/v/vux-loader.svg?style=flat-square",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.npmjs.com/package/vux-loader"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://img.shields.io/npm/dm/vux-loader.svg?style=flat-square",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("vux-loader")]), _vm._v("工具的作用是对"), _c('code', [_vm._v(".vue")]), _vm._v("代码进行预处理，不限于 vux 组件库。")]), _vm._v(" "), _c('p', [_vm._v("它是针对"), _c('code', [_vm._v("webpack+vue-loader")]), _vm._v("项目的工程化工具，简化了webpack插件和loader的使用和编写，支持在vue-loader处理之前进行预处理，同时内置对vux组件专用的配置和优化插件。")]), _vm._v(" "), _c('p', [_vm._v("当然除了.vue文件外，你还可以对js文件进行预处理。说好的处理.vue文件，为什么连"), _c('code', [_vm._v("js")]), _vm._v("文件也不放过呢？因为只有处理js才能实现理想工程化。举个例子，如果用户需要在"), _c('code', [_vm._v("main.js")]), _vm._v("中调用vux的plugin，他需要这样做：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" AlertPlugin "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux/src/plugins/Alert'")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" ToastPlugin "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux/src/plugins/Toast'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_vm._v("虽然路径不长，但是看着相当不和谐，为了简化这个操作vux提供了更简洁的写法：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { AlertPlugin, ToastPlugin } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_vm._v("这个操作即是通过"), _c('code', [_vm._v("js-parser")]), _vm._v("插件解析main.js里的"), _c('code', [_vm._v("import")]), _vm._v("语法来实现的，最终进入"), _c('code', [_vm._v("babel")]), _vm._v("处理的代码和上面单独引入一致。")]), _vm._v(" "), _c('p', [_vm._v("这个工具也许会帮你进一步打开"), _c('code', [_vm._v("Vue")]), _vm._v("项目工程化的思路。")]), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_c('p', [_vm._v("作为通用工具，即使你没有使用 "), _c('code', [_vm._v("VUX")]), _vm._v("，依然可以使用它来进行各种代码处理。")])]), _vm._v(" "), _c('h2', [_vm._v("为什么不使用 babel-plugin-import")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("VUX 希望使用源码分发")]), _vm._v(" "), _c('li', [_vm._v("VUX 希望无侵入地解决一系列的工程问题，不需要用户手动配置 webpack")]), _vm._v(" "), _c('li', [_vm._v("VUX 希望能统计(匿名)使用情况")])]), _vm._v(" "), _c('p', [_vm._v("而上面这些单纯使用 "), _c('code', [_vm._v("babel-plugin-import")]), _vm._v(" 无法做到，所以造了个轮子。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-772b83f0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-772b83f0"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/about-190.vue
// module id = 2886
// module chunks = 620